import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";

export interface SupabaseMetrics {
  active_connections: number;
  queries_per_second: number;
  avg_query_time: number;
  cache_hits: number;
  cache_misses: number;
  storage_usage: number;
  edge_function_invocations: number;
  auth_events: Record<string, any>;
  auth_signups: number;
  auth_logins: number;
  auth_failures: number;
  storage_bucket_usage: Record<string, number>;
  edge_function_details: Record<string, any>;
  regional_latency: Record<string, number>;
  query_performance: {
    slow_queries: number;
    avg_execution_time: number;
    query_types: Record<string, number>;
  };
  connection_pool_stats: {
    active: number;
    idle: number;
    max_connections: number;
    waiting: number;
  };
  storage_analytics: {
    total_size: number;
    files_count: number;
    bucket_usage: Record<string, number>;
  };
  realtime_subscription_stats: {
    active_subscriptions: number;
    messages_sent: number;
    messages_received: number;
  };
}

export const useSupabaseMetrics = () => {
  return useQuery({
    queryKey: ['supabase-metrics'],
    queryFn: async () => {
      console.log('Fetching Supabase metrics...');
      const { data, error } = await supabase
        .from('supabase_metrics')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(100);

      if (error) {
        console.error('Error fetching Supabase metrics:', error);
        throw error;
      }

      console.log('Supabase metrics fetched:', data);
      return data as SupabaseMetrics[];
    },
    refetchInterval: 30000, // Atualiza a cada 30 segundos
  });
};